import { createSlice } from "@reduxjs/toolkit"
import api from "../../api/services"
import { Apply3Response } from "../../api/types/apply3"

type initialState = {
    response: Apply3Response | null
}

const apply3Slice = createSlice({
    name: "apply3",
    initialState: { response: null } as initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addMatcher(
            api.endpoints.apply3.matchFulfilled,
            (state, action) => {
                state.response = action.payload
            }
        )
    }
})

export default apply3Slice.reducer




